import axios from 'axios';
import { fromEvent, interval, merge, Subject } from 'rxjs';
import { buffer, filter, first } from 'rxjs/operators';

import type { ClickStreamEvent as LegacyClickStreamEvent } from '../utilities/moMetrics/clickStreamEvent';
import type { ClickStreamEvent } from '../hooks/useAnalyticEvent';

type AnalyticsEvent = LegacyClickStreamEvent | ClickStreamEvent;

const EVENT_BATCH_INTERVAL_MS = 3000;

const submittedQueue = new Subject<AnalyticsEvent[]>();
const eventQueue = new Subject<AnalyticsEvent>();

const intervalTrigger = interval(EVENT_BATCH_INTERVAL_MS);
const manualTrigger = new Subject<void>();
const unloadTrigger = fromEvent(document, 'pagehide');

const eventObservable = eventQueue.pipe(
  buffer(merge(intervalTrigger, manualTrigger, unloadTrigger)),
  filter(b => !!b.length)
);

const AnalyticsApi = {
  queue: (event: AnalyticsEvent) => {
    eventQueue.next(event);
  },
  queueAndSendAll: (event: AnalyticsEvent) => {
    const promise = new Promise(resolve => {
      submittedQueue.pipe(first()).subscribe(resolve);
    });
    eventQueue.next(event);
    manualTrigger.next();
    return promise;
  },
  recordNow: (analyticsEvents: AnalyticsEvent[]): Promise<any> => {
    const url = `${process.env.CARVANA_APP_TRADES_API}/api/v4/analytics`;
    return axios.post(url, analyticsEvents);
  }
};

eventObservable.subscribe({
  next: async events => {
    try {
      await AnalyticsApi.recordNow(events);
      submittedQueue.next(events);
    } catch (_error) {
      submittedQueue.next([]);
    }
  }
});

export default AnalyticsApi;
